const CallCenterWorkingHours = () => (
    <div
        data-testid="call-center-working-hours"
        className="w-full rounded-[0.5625rem] bg-primary-1100 py-[0.625rem] px-1 flex flex-col items-center"
    >
        <span data-testid="working-hours-monday-friday-text" className="text-dark text-[0.9375rem] md:text-[1.0625rem] font-dmSansMedium font-medium">
            Monday - Friday: 6AM - 7PM PT
        </span>

        <span data-testid="working-hours-saturday-text" className="text-dark text-[0.9375rem] md:text-[1.0625rem] font-dmSansMedium font-medium">
            Saturday: 7:30AM - 4PM PT
        </span>
    </div>
);

export default CallCenterWorkingHours;